import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-view-formatted-editor-text',
  templateUrl: './view-formatted-editor-text.component.html',
  styleUrls: ['./view-formatted-editor-text.component.scss'],
})
export class ViewFormattedEditorTextComponent {
  // content to be shown on template
  @Input() content: string;
}
